/**
 * Parses the `labelsPerExhibit` value from a class config blob that may be JSON or a raw object.
 * Returns `null` when the value is absent or invalid.
 */
export const parseLabelsPerExhibitConfig = (value: unknown): number | null => {
  if (value === undefined || value === null) return null
  let source = value
  if (typeof source === 'string') {
    try {
      source = JSON.parse(source)
    } catch {
      return null
    }
  }
  if (typeof source !== 'object' || source === null) return null
  const raw = (source as Record<string, unknown>).labelsPerExhibit
  if (raw === undefined || raw === null) return null
  const numeric =
    typeof raw === 'number'
      ? raw
      : typeof raw === 'string'
        ? Number(raw)
        : Number.parseFloat(String(raw))
  if (!Number.isFinite(numeric)) return null
  const rounded = Math.floor(numeric)
  if (rounded < 1) return null
  return rounded
}

export const resolveLabelsPerExhibitFromClass = (klass: unknown): number => {
  if (!klass || typeof klass !== 'object') return 1
  const candidate = klass as {
    parameters?: unknown
    ruleOverrides?: unknown
    catalogClass?: { rules?: unknown } | null | undefined
  }
  const catalogRules =
    candidate.catalogClass && typeof candidate.catalogClass === 'object'
      ? (candidate.catalogClass as { rules?: unknown }).rules
      : undefined
  return (
    parseLabelsPerExhibitConfig(candidate.parameters) ??
    parseLabelsPerExhibitConfig(candidate.ruleOverrides) ??
    parseLabelsPerExhibitConfig(catalogRules) ??
    1
  )
}
